<template>
  <div class="fake-progress-bar">
    <div class="progress-container">
      <div class="progress-bar" :style="{ width: progress + '%' }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FakeProgressBar',
  data() {
    return {
      progress: 0,
      interval: null,
      isComplete: false,
    }
  },
  mounted() {
    this.startProgress()
  },
  beforeDestroy() {
    this.clearInterval()
  },
  methods: {
    startProgress() {
      const totalDuration = 4000
      const fastPhase = 2000
      const slowPhase = 1000

      const startTime = Date.now()

      const updateProgress = () => {
        const elapsed = Date.now() - startTime

        if (elapsed >= totalDuration) {
          this.progress = 100
          this.isComplete = true
          this.clearInterval()
          this.$emit('complete')
          return
        }

        let progress
        if (elapsed <= fastPhase) {
          // Fast phase: reach 70% in first 2 seconds
          progress = (elapsed / fastPhase) * 70
        } else {
          // Slow phase: reach remaining 30% in last 1 second
          const slowElapsed = elapsed - fastPhase
          progress = 70 + (slowElapsed / slowPhase) * 30
        }

        this.progress = Math.min(progress, 100)
      }

      // Update every 50ms for smooth animation
      this.interval = setInterval(updateProgress, 50)
    },
    clearInterval() {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fake-progress-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.progress-container {
  flex: 1;
  height: 2px;
  background-color: #F7F7F7;
  border-radius: 2px;
  overflow: hidden;
  position: relative;
}

.progress-bar {
  height: 100%;
  background: #6A1EBB;
  border-radius: 2px;
  transition: width 0.1s ease-out;
  position: relative;

}

// Smooth animation for the progress bar
.progress-bar {
  transition: width 0.1s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>
